import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import play1 from "../../assets/images/play1.jpg"
import play2 from "../../assets/images/play2.jpg"
import play3 from "../../assets/images/play3.jpg"
import play4 from "../../assets/images/play4.jpg"
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import styled from "styled-components";
const List = styled.ul`
    margin-top: 10px;
    margin-bottom: 20px;
`;
const Item = styled.li`
    display: block;
    color: #444444;
    line-height: 23px;
    letter-spacing: -0.7px;
`;

const Playground = () => {
    const textList = [
        '강아지들이 마음껏 뛰어놀 수 있는 잔디 운동장입니다.' +
        '드넓은 운동장에서 강아지가 산책줄 없이 마음껏 뛰어놀 수 있습니다.넘어져도 안전하며, 스트레스 풀기에 제격입니다.'
    ];
    const list = [
        '* 오프리시 공간으로 줄을 풀어도 되는 공간입니다.',
        '* 각종 사고를 예방하기 위해 소중한 강아지를 꼭 가까이서 케어해주세요.',
    ]


    const textList2 =
        '강아지숲에는 자연의 아름다움을 품은 잔디 운동장 세 곳 (큰운동장/작은운동장/ 네이처풀 운동장)이 있습니다.\n\n' +
        '월별 로테이션 일정에 따라 강아지 체중별로 이용할 수 있는 구역을 나누어 다양한 환경에서 강아지들이 마음껏 뛰어놀 수 있도록 하고 있습니다.'
    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="운동장"
                desc="강아지숲 운동장을 안내해 드립니다."
            />

            {/*section 1*/}
            <LeftSection
                title="강아지숲 운동장"
                enTitle="d.forest Fields"
                textList={textList}
                content={<List>
                    {list.map((item, index) => (<Item key={index}>{item}</Item>))}
                </List>}
                img1={play1}
                img2={play2}
            />


            {/*section 2*/}
            <RightSection
                textList={textList2}
                top={"80px"}
                img1={play3}
                img2={play4}
            />

        </>
    );
};

export default Playground;
